const pad = (num) => (num < 10 ? '0' : '') + num

const toIsoString = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`

export default toIsoString